import { Controller } from 'stimulus'

/**
 * Manages js for the saving progress step (StimulusJS controller)
 *
 * @class SavingProgressController
 * @memberof Controllers
 */
export default class extends Controller {
  static targets = []

  timeout = null

  /**
   * @function Controllers.SavingProgressController.connect
   * @memberof Controllers
   *
   * @return {undefined} Sets timeout to trigger next
   *
   */
  connect() {
    this.timeout = setTimeout(() => {
      this.element.dispatchEvent(new CustomEvent('full-app:next'))
    }, 5000)
  }
}
